import React from 'react';

interface DisclaimerDialogProps {
  isOpen: boolean;
  onClose: () => void;
  showVersion?: boolean;
}

// App version - update this when releasing new versions
export const APP_VERSION = '1.0.0';

const DisclaimerDialog: React.FC<DisclaimerDialogProps> = ({ isOpen, onClose, showVersion = false }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[#3C4959]/80 backdrop-blur-sm flex items-center justify-center p-3 z-[9999]">
      <div
        className="bg-white border border-black/25 rounded-[48px] p-6 w-full max-w-[340px] max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Title */}
        <h2 className="font-serif text-xl font-bold text-black m-0 mb-5 text-center">
          Terms of Use & Disclaimer
        </h2>

        {/* Scrollable content */}
        <div className="flex-1 overflow-y-auto mb-5 pr-1">
          {/* Section 1 */}
          <div className="mb-4">
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              1. Acceptance & Usage:
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Acceptance: By using this service, you agree to these terms.
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Permitted Use: This service is for educational purposes only. Commercial or illegal use is strictly prohibited.
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Intellectual Property: All content is owned by the development team. Unauthorized use, reproduction, or distribution is forbidden.
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Environment: Operate the service in a safe, open space.
            </p>
          </div>

          {/* Section 2 */}
          <div className="mb-4">
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              2. Health & Liability:
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              AR Risks (Augmented Reality Risks): Use may cause discomfort or disorientation. It is not recommended for pregnant individuals, epilepsy patients, or other sensitive groups.
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Safety: Always use the service in well-lit, secure environments.
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Disclaimer: This application is for reference purposes only. Users assume all risks associated with its use.
            </p>
          </div>

          {/* Section 3 */}
          <div className="mb-4">
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              3. Privacy Policy:
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Data Collected: Only anonymous data (non-personally identifiable information) is collected.
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Purpose: Data is used solely to improve user experience and fix bugs.
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Protection: Data is encrypted and will never be sold. Any future partnership involving data sharing will require additional user consent.
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              User Rights: You may request access, modification, or deletion of your data via: workformoney627@gmail.com.
            </p>
          </div>

          {/* Section 4 */}
          <div className="mb-4">
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              4. Copyright:
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Ownership: All content, including source code and visual assets, belongs to Liau Zi-Hong, or their designated partners.
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Prohibited Actions: Unauthorized reproduction, modification, commercial exploitation, or public display of the content is strictly prohibited.
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Collaboration/Licensing: Please contact the development team for any collaboration or licensing inquiries.
            </p>
          </div>

          {/* Section 5 */}
          <div className="mb-4">
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              5. Attribution and Credits
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Icons (Font Awesome): Icons by Font Awesome. Some icons are licensed under CC BY 4.0 and have been modified from their original form.
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0 mt-2">
              Google Fonts
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              Font used: Noto Serif Traditional Chinese - Licensed under SIL Open Font License, Version 1.1.
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0 mt-2">
              Google Icons: Portions of this software are derived from Google Material Symbols, licensed under the Apache License, Version 2.0.
            </p>
          </div>

          {/* Section 6 */}
          <div className="mb-0">
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              6. Updates:
            </p>
            <p className="font-serif text-sm font-bold text-black leading-relaxed m-0">
              These terms may be revised at any time. Changes will be announced to users.
            </p>
          </div>
        </div>

        {/* OK Button */}
        <div className="flex justify-center">
          <button
            className="bg-[#8EA6C0] text-white py-4 px-14 border-none rounded-full font-serif text-xl font-bold cursor-pointer transition-all active:scale-[0.96] active:opacity-90"
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerDialog;
